// extracted by mini-css-extract-plugin
export var errorIcon = "_p1-1";
export var nameLogo = "_p1-0";